import { ReactElement } from 'react';

import { GoogleAnalytics, PostHog } from 'analytics/components';

export const Analytics = ({ children }: { children?: ReactElement }) => {
  return (
    <PostHog>
      <GoogleAnalytics>{children}</GoogleAnalytics>
    </PostHog>
  );
};
